import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateUser } from '../../actions/user';

import AcceptanceConditionsModal from '../../components/AcceptanceConditionsModal';
import ContentContainer from '../../components/ContentContainer';
import SubscriptionCard from '../../components/SubscriptionCard';

import BORROWER_ASSET from './Borrower.svg';
import OWNER_ASSET from './Owner.svg';

class JoinSubscription extends Component {
  constructor(props) {
    super(props);
    this.toggleConditions = this.toggleConditions.bind(this);
    this.toggleConditionsPopup = this.toggleConditionsPopup.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.state = {
      selected: this.props.user.subscription ? this.props.user.subscription : 'Borrower',
      completed: false,
    };
  }

  setSelected(id) {
    this.setState({
      selected: id,
    });
  }

  continue() {
    this.toggleConditions();
    this.props.dispatch(
      updateUser({
        subscription: this.state.selected,
      }),
    );

    this.setState(
      {
        completed: true,
      },
      () => {
        setTimeout(() => this.props.history.push('/join/details'), 300);
      },
    );
  }

  toggleConditionsPopup() {
    this.toggleConditions();
  }

  toggleConditions() {
    this.setState({
      showAcceptanceConditions: !this.state.showAcceptanceConditions,
    });
  }

  render() {
    const Continue = withRouter(({ history }) => (
      <button
        className={css(styles.continue)}
        onClick={this.toggleConditionsPopup}
        history={history}
        onClickPass={this.continue}
      >
        Continue{this.state.selected ? ' as ' + this.state.selected : false}
      </button>
    ));
    return (
      <div
        className={css(styles.container, this.state.completed ? styles.container_completed : null)}
      >
        <ContentContainer>
          <AcceptanceConditionsModal
            open={this.state.showAcceptanceConditions}
            toggle={this.toggleConditions}
            history={history}
            onClickPass={() => {
              this.continue(history);
            }}
          >
            {this.state.AcceptanceConditions}
          </AcceptanceConditionsModal>
          <h1 className={css(styles.heading)}>Select your subscription</h1>
          <div className={css(styles.cards)}>
            <SubscriptionCard
              id="Owner"
              icon={OWNER_ASSET}
              title="I own dogs I'd like to share"
              includes={[
                'Connect with Unlimited Dog Lovers',
                'List all your Dogs - find compatible local Dog Lovers and/or Dogs',
                'Travelling? Find In-Home Dog Sitters when your dog wants to stay home',
                'Remain anonymous until you Accept a Match',
                'Verified and Reviewed Dog Borrowers/ Sitters',
                'Member Support Services',
              ]}
              price={49.99}
              promoPrice={30.0}
              promoTitle="#COLLECTIVEGIVING"
              promoText={
                <span>
                  One year subscription for $30.00 <br />
                  100% Pooch Pleasure Guarantee: No connections in your first year? Get your second
                  year FREE!
                </span>
              }
              conditions={
                <ul className={css(styles.conditions_list)}>
                  <li className={css(styles.conditions_list_item)}>
                    <p>I am the legal owner/ guardian of my dog(s).</p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>My dog(s) is registered.</p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>
                      My dog(s) is safe to share - healthy, over 3 months of age, not registered as
                      ‘dangerous’ or ‘menacing’ dog.
                    </p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>I am over 18 years of age.</p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>
                      I have not been convicted of an offence under the Dog Control Act (1996),
                      Parts 1 and 2 of Animal Welfare Act (1999), s26ZZP of the Conservation Act
                      (1987) or s56I of the National Parks Act (1980).
                    </p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>
                      I have read the Terms of Service and will comply with Member Code of Conduct.
                    </p>
                  </li>
                </ul>
              }
              selected={this.state.selected}
              handleSelect={this.setSelected}
            />
            <SubscriptionCard
              id="Borrower"
              icon={BORROWER_ASSET}
              title="I want to find a dog to share"
              includes={[
                'Connect with Unlimited Dogs',
                'Find a compatible local pooch. Receive notifications of Accepted Dog Shares',
                'Up for National Travel and Free accom, with a Dog-Fix? Go In-Home Dog Sitting',
                'Remain anonymous until you Request a Match',
                'Verified and Reviewed Dog Owners',
                'Member Support Services',
              ]}
              price={49.99}
              promoPrice={30.0}
              promoTitle="#COLLECTIVEGIVING"
              promoText={
                <span>
                  One year subscription for $30.00 <br />
                  100% Pooch Pleasure Guarantee: No connections in your first year? Get your second
                  year FREE!
                </span>
              }
              conditions={
                <ul className={css(styles.conditions_list)}>
                  <li className={css(styles.conditions_list_item)}>
                    <p>I am over 18 years of age.</p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>
                      I have not been convicted of an offence under the Dog Control Act (1996),
                      Parts 1 and 2 of Animal Welfare Act (1999), s26ZZP of the Conservation Act
                      (1987) or s56I of the National Parks Act (1980).
                    </p>
                  </li>
                  <li className={css(styles.conditions_list_item)}>
                    <p>
                      I have read the Terms of Service and will comply with Member Code of Conduct.
                    </p>
                  </li>
                </ul>
              }
              selected={this.state.selected}
              handleSelect={this.setSelected}
            />
          </div>
          <div className={css(styles.selection_type)}>
            You{"'"}ve selected {this.state.selected === 'Owner' ? 'an' : 'a'} {'"'}
            {this.state.selected}
            {'"'} subscription.
          </div>
          <div className={css(styles.actions)}>
            <Continue />
          </div>
        </ContentContainer>
      </div>
    );
  }
}

JoinSubscription.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',

    [Theme.mobile_query]: {
      padding: '50px 15px',
    },
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  heading: {
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  selection_type: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 60,
    marginBottom: 20,
    fontWeight: 'bold',
    textAlign: 'center',

    [Theme.mobile_query]: {
      marginTop: 30,
      marginBottom: 30,
      fontSize: 14,
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,

    [Theme.mobile_query]: {
      marginTop: 0,
    },
  },
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
  },
  conditions_list_item: {
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    marginBottom: 20,
    fontSize: 15,
    lineHeight: '1.4',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinSubscription);



// WEBPACK FOOTER //
// ./src/views/JoinSubscription/index.js